import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { UserPlus, Users, Palette } from "lucide-react";
import { useMembers } from "@/hooks/useMembers";
import { MemberTable, ResetLinkDialog, AddMemberDialog, InviteCreatedDialog } from "@/components/admin/AdminParts";
import { BrandingPanel } from "@/components/admin/BrandingPanel";

const TABS = [["members", "Members", Users], ["branding", "Branding", Palette]];

export default function Admin() {
  const { activeWorkspaceId, currentRole } = useAuth();
  const m = useMembers(activeWorkspaceId);
  const [tab, setTab] = useState("members");
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ email: "", role: "reviewer" });

  const submit = async () => { if (await m.add(form)) setOpen(false); };

  return (
    <div className="p-8 max-w-[1400px] mx-auto" data-testid="admin-page">
      <div className="flex items-end justify-between mb-6">
        <div>
          <div className="label-cap text-amber-500">// {tab === "branding" ? "WORKSPACE BRANDING" : "USER MANAGEMENT"}</div>
          <h1 className="font-heading text-3xl font-extrabold text-slate-100 mt-1 flex items-center gap-2"><Users className="w-6 h-6 text-amber-400" /> Administration</h1>
          <p className="text-slate-400 text-sm mt-1">{tab === "branding" ? "Your company's name, logo, accent and footer on generated documents." : "Admin, Reviewer, and Read-Only role management with per-workspace access."}</p>
        </div>
        {tab === "members" && (
          <button onClick={() => setOpen(true)} className="bg-amber-500 hover:bg-amber-400 text-slate-950 font-semibold px-4 py-2 rounded-md text-sm inline-flex items-center gap-2" data-testid="add-member-button">
            <UserPlus className="w-4 h-4" /> Add member
          </button>
        )}
      </div>
      <div className="flex gap-1 mb-6 border-b border-slate-800" data-testid="admin-tabs">
        {TABS.map(([k, label, Icon]) => (
          <button key={k} onClick={() => setTab(k)} className={`px-4 py-2 text-sm inline-flex items-center gap-2 border-b-2 -mb-px ${tab === k ? "border-amber-500 text-amber-400" : "border-transparent text-slate-400 hover:text-slate-200"}`} data-testid={`admin-tab-${k}`}><Icon className="w-4 h-4" /> {label}</button>
        ))}
      </div>
      {tab === "members" && (
        <>
          <MemberTable members={m.members} onRole={m.changeRole} onReset={m.resetLink} onRemove={m.remove} />
          <ResetLinkDialog reset={m.reset} onClose={m.clearReset} onCopy={m.copyReset} />
          <AddMemberDialog open={open} onOpenChange={setOpen} form={form} setForm={setForm} onSubmit={submit} />
          <InviteCreatedDialog invited={m.invited} onClose={m.clearInvited} />
        </>
      )}
      {tab === "branding" && <BrandingPanel wid={activeWorkspaceId} canEdit={currentRole === "admin"} />}
    </div>
  );
}
